const prefix = "[ui] ";

export const TOGGLE_ABOUT = prefix + "TOGGLE_ABOUT";
export const toggleAbout = () => ({
  type: TOGGLE_ABOUT,
});
